import React from 'react';
import AdminPage from 'lib/admin-kit/components/AdminPage';
import AdminTable from 'lib/admin-kit/components/AdminTable';
import { Tabs, Tab } from '@decisiv/ui-components';
import PeriodSelector from './PeriodSelector';
import { formatCost, formatCount } from './format';

const INDEX_ENDPOINT = '/internal_admin/admin_kit/ai_usage_logs';

const usageColumns = [
  {
    name: 'feature',
    title: 'Feature',
    DataCell: ({ rowData }) => rowData.feature ?? '—',
  },
  {
    name: 'subtype',
    title: 'Subtype',
    DataCell: ({ rowData }) => rowData.subtype ?? '—',
  },
  {
    name: 'count',
    title: 'Calls',
    DataCell: ({ rowData }) => formatCount(rowData.count),
  },
  {
    name: 'input_tokens',
    title: 'Input Tokens',
    DataCell: ({ rowData }) => formatCount(rowData.input_tokens),
  },
  {
    name: 'output_tokens',
    title: 'Output Tokens',
    DataCell: ({ rowData }) => formatCount(rowData.output_tokens),
  },
  {
    name: 'cost_usd',
    title: 'Cost',
    DataCell: ({ rowData }) => formatCost(rowData.cost_usd),
  },
];

const userColumns = [
  {
    name: 'user_email',
    title: 'User',
    DataCell: ({ rowData }) =>
      rowData.user_id ? (
        <a
          href={`${INDEX_ENDPOINT}/users/${rowData.user_id}`}
          style={{ textDecoration: 'underline' }}
        >
          {rowData.user_email ?? rowData.user_id}
        </a>
      ) : (
        rowData.user_email ?? '—'
      ),
  },
  {
    name: 'count',
    title: 'Calls',
    DataCell: ({ rowData }) => formatCount(rowData.count),
  },
  {
    name: 'input_tokens',
    title: 'Input Tokens',
    DataCell: ({ rowData }) => formatCount(rowData.input_tokens),
  },
  {
    name: 'output_tokens',
    title: 'Output Tokens',
    DataCell: ({ rowData }) => formatCount(rowData.output_tokens),
  },
  {
    name: 'cost_usd',
    title: 'Cost',
    DataCell: ({ rowData }) => formatCost(rowData.cost_usd),
  },
];

const totalsLine = (totals = {}) => (
  <div style={{ fontSize: 13, color: '#555', padding: '4px 0' }}>
    Total: {formatCount(totals.count)} calls, {formatCount(totals.input_tokens)}{' '}
    input tokens, {formatCount(totals.output_tokens)} output tokens,{' '}
    {formatCost(totals.cost_usd)}
  </div>
);

const Show = ({
  dealerId,
  dealerName,
  rows = [],
  totals = {},
  users = [],
  userTotals = {},
  period = 'day',
}) => (
  <AdminPage
    title={dealerName ?? dealerId}
    breadcrumbs={[
      { text: 'AI Usage', href: INDEX_ENDPOINT },
      { text: dealerName ?? dealerId },
    ]}
  >
    <PeriodSelector
      period={period}
      basePath={`${INDEX_ENDPOINT}/${dealerId}`}
    />

    <Tabs defaultSelectedId="usage">
      <Tab id="usage" title="Usage">
        <div style={{ marginTop: 16 }}>
          <AdminTable
            columns={usageColumns}
            data={rows}
            getRowKey={(r) => `${r.feature}-${r.subtype}`}
            emptyText="No AI usage recorded for this dealer in this period."
            toolbar={() => totalsLine(totals)}
          />
        </div>
      </Tab>
      <Tab id="users" title="Users">
        <div style={{ marginTop: 16 }}>
          <AdminTable
            columns={userColumns}
            data={users}
            getRowKey={(r) => r.user_id ?? 'no-user'}
            emptyText="No users recorded AI usage at this dealer in this period."
            toolbar={() => totalsLine(userTotals)}
          />
        </div>
      </Tab>
    </Tabs>
  </AdminPage>
);

export default Show;
